export enum MultiSelectSidebarMode {
  None,
  BulkEdit,
}

export type SelectedId = string | number;

export interface IMultiSelectSidebarStore {
  isMultiEditMode: boolean;
  selectedIds: SelectedId[];
  selectedRows: unknown[];
  mode: MultiSelectSidebarMode;
}

export interface IMultiSelectSidebarStoreSegment {
  multiSelectSidebar: IMultiSelectSidebarStore;
}
